<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="10">
        <h2 class="top-title text-center" v-html="$t(`${(firstUser)? 'firstUser' : 'alreadyUser'}.title`)"/>
        <v-spacer class="my-3"/>
        <p v-if="!authenticated" class="headline text-center"
           v-html="$t(`${(firstUser)? 'firstUser' : 'alreadyUser'}.subtitle`, { email: magicLinkEmail })"/>
      </v-col>
    </v-row>
    <v-spacer class="my-5"/>
    <v-row align="center" justify="center">
      <lottie :options="lottieOptions" :height="250"/>
    </v-row>
    <v-spacer class="my-10"/>
    <v-row align="center" justify="center">
      <p v-if="!canResendEmail" class="text-center" v-html="$t('resend', { seconds: secondsToResend })"/>
      <p v-else class="clickable-text text-center my" @click="resendEmail" v-html="$t('btnResend')"/>
    </v-row>
  </v-container>
</template>

<script>
  import { Auth } from 'aws-amplify';
  import {mapMutations} from 'vuex';
  import CognitoAuthRepository from "../../../repositories/cognitoAuth"
  import AuthRepository from '../../../repositories/auth';
  import ExternalUserRepository from '../../../repositories/externalUser'

  import * as animationData from "@/assets/animations/magic-link.json";

  export default {
    name: "PasswordlessChecking",
    data() {
      return {
        lottieOptions: { animationData: animationData.default, },

        // Status Available: PRE-NEW-USER, PRE-SWISET-USER, AUTH-NEW-USER, AUTH-SWISET-USER
        // AUTH status is made to bring authenticated-feedback to the user
        status: 'PRE-NEW-USER',
        canResendEmail: false,
        secondsToResend: 180,

        whitelabelUserEmail: this.$store.state.whitelabel.userEmail,
        magicLinkEmail: '',
        cognitoUser: null, // Tracks authentication flow state in this object
        getLastCodeInterval: null,
        emailResendInterval: null
      };
    },
    computed: {
      firstUser() {
        return this.status.endsWith('NEW-USER');
      },
      authenticated() {
        return this.status === 'AUTH-NEW-USER' || this.status === ' AUTH-SWISET-USER';
      },
      _seconds: () => 1000,
    },
    mounted() {
      /* eslint-disable no-console */
      if(this.getLastCodeInterval) clearInterval(this.getLastCodeInterval)
      if(this.emailResendInterval) clearInterval(this.emailResendInterval)
      this.setTimerEmailResend();
      this.initializeSignIn(this.whitelabelUserEmail);
      /* eslint-enable no-console */
    },
    methods: {
      ...mapMutations(['setToken' , 'setUser', 'setUserDetails', 'setPreferredLanguage']),
      async initializeSignIn(whitelabelUserEmail) {
        /* eslint-disable no-console */
        this.cognitoUser = await Auth.signIn(whitelabelUserEmail);
        let additionalParams = this.$store.state.whitelabel.partner.shortName+','+this.$store.state.whitelabel.isNewUser
        this.cognitoUser = await Auth.sendCustomChallengeAnswer(this.cognitoUser,additionalParams);
        console.log(this.cognitoUser) // challengeParam.securityCode!
        this.magicLinkEmail = this.cognitoUser.challengeParam.magicLinkEmail
        this.getLastCodeInterval = setInterval(async () => {
          try {
            const response = await CognitoAuthRepository.getLastCode(whitelabelUserEmail,this.cognitoUser.challengeParam.securityCode);
            if (response.data !== null && response.data != '') {
              console.log('Got non-null value:', response.data);
              await this.submitCode(response.data)
            }
          } catch (error) {
            console.error('Error in polling:', error);
          }
        }, 10000); // Adjust the interval as needed (currently set to 1000ms or 1 second)
        /* eslint-enable no-console */
      },
      setTimerEmailResend() {
        let endTime = new Date();
        endTime.setSeconds(endTime.getSeconds() + (this.secondsToResend + 1));
        this.emailResendInterval = setInterval(() => {
          let now = new Date();
          let distance = endTime.getTime() - now.getTime();
          if(distance < 1) {
            this.canResendEmail = true;
            clearInterval(this.emailResendInterval)
            return;
          }
          this.secondsToResend = Math.floor(distance / this._seconds);
        }, 1000);
      },
      resendEmail() {
        this.secondsToResend = 180;
        this.canResendEmail = false;
        if(this.getLastCodeInterval) clearInterval(this.getLastCodeInterval)
        if(this.emailResendInterval) clearInterval(this.emailResendInterval)
        this.setTimerEmailResend();
        this.initializeSignIn(this.whitelabelUserEmail);
        alert(this.$t('resentLink', { email: this.magicLinkEmail }));
      },
      async submitCode(code) {
        /* eslint-disable no-console */
        const answer = code
  
        // Send the answer to the User Pool
        try {
          this.cognitoUser = await Auth.sendCustomChallengeAnswer(this.cognitoUser, answer+'').catch(function(){
            console.log("ERROR LEYENDO CODIGO")
          });
          console.log('User authenticated successfully');
          console.log(this.cognitoUser)
        } catch (error) {
          console.log(error)
          console.log('Apparently the user did not enter the right code');
        }
  
        // Check if the user is authenticated now
        try {
          console.log('Checking if user is authenticated')
          // This will throw an error if the user is not yet authenticated:
          let currentSession = await Auth.currentSession() //accessToken, idToken and refreshToken in here!
          clearInterval(this.getLastCodeInterval)
          console.log('Setting token')
          this.setToken(`Bearer ${currentSession.idToken.jwtToken}`)
          console.log('Setting User')
          await AuthRepository.getUser().then((response) => {this.setUser(response.data);});
          console.log('Setting language')
          await AuthRepository.getLanguage().then((response) => { this.setPreferredLanguage(response.data); });
          console.log('Setting userDetails')
          await AuthRepository.getUserDetails().then((response) => { this.setUserDetails(response.data); });
          console.log('Analysis of new user login...')
          let externalUser = {
            partner: { id: this.$store.state.whitelabel.partner.id },
            user: { id: this.$store.state.user.id },
            externalUserEmail: this.$store.state.whitelabel.userEmail,
            externalUserId: this.$store.state.whitelabel.userId
          }
          console.log('Posting external user')
          try{await ExternalUserRepository.getOrCreateExternalUser(externalUser)}catch(err){console.log('err on external user')}
          console.log('Onto onboard!')
          await this.$router.push('/onboard');
        } catch (error) {
          if (error instanceof DOMException || error.name === "QuotaExceededError") {
            // Handle the quota exceeded error
            console.error("The quota has been exceeded.");
            // You can show a message to the user or take other actions to handle the error.
          } else {
            console.error(error);
            console.log("Apparently the user did not enter the right code, Allowing for re-starting session");
            this.canResendEmail = true;
            alert(this.$t('codeError'))
            this.$router.go();
          }
        }
        /* eslint-enable no-console */
      },
    },
  };
</script>

<style lang="scss" scoped>
@import "../../../global.scss";

.top-title {
  color: var(--v-mainBlack-base);
  font: 28px 'Avenir' !important;
  font-weight: bold !important;
}

.headline {
  font: 17px 'Avenir' !important;
}

.clickable-text {
  color: $border-color;
  font: 14px 'Avenir';
  text-decoration: underline;
  cursor: pointer;
}
</style>

